import React from "react";
import "./Loader.css";

function Loader() {
  return (
    <div className="loader-container">
      <div className="loader-content">
        <div className="spinner"></div>
        <p className="loader-text">Preparing Your Adventure</p>
      </div>
    </div>
  );
}

export default Loader;
